var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-policy-content"},[_c('div',{staticClass:"header"},[_c('DefaultHeader')],1),_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.policyInfo.i18nContent)}}),_c('div',{staticClass:"footer"},[_c('CommonFooter',{staticClass:"common-footer",attrs:{"showFooterLink":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }